/* tslint:disable */
const fr = {
    validation: {
        validation_required: 'Le champ {key} doit être rempli',
        validation_string: 'Le champ {key} doit être composé de caractères',
        validation_int: 'Le champ {key} doit être un nombre',
        validation_date: 'Le champ {key} doit être une date',
        fields: {
            insight: 'Question',
            todo: 'A faire',
            responsible: 'Personne responsable',
            contacttill: 'Rendez-vous',
            topics: 'Les métiers',
        },
    },
    errors: {
        validation: {
            nameOrTenant: "Entrez le nom de l'entreprise ou le prénom/nom",
            title: 'Veuillez saisir un titre',
            description: 'Veuillez saisir une description',
            dynamic_field: 'Veuillez saisir un titre',
            name: 'Veuillez saisir un nom',
            email: 'Veuillez saisir une adresse e-mail valide',
            emailTaken: 'Cette adresse e-mail est déjà utilisée',
            password: 'Veuillez saisir un mot de passe valide',
            passwordIsIncorrect: 'Le mot de passe actuellement saisi est incorrect',
            currentPassword: 'Veuillez saisir le mot de passe actuel',
            shortPassword: 'Le mot de passe doit comporter au moins 8 caractères',
            firstName: 'Veuillez saisir votre prénom',
            lastName: 'Veuillez saisir le nom de famille',
            shortFirstNameOrLastName: 'Le prénom / nom de famille doit comporter au moins deux caractères',
            bkp: 'Veuillez saisir un numéro de corps de métier (Suisse : CFC)',
            abbreviation: 'Veuillez saisir une abréviation',
            order: 'Veuillez saisir le tri',
            lesson: 'Veuillez saisir un enseignement',
            phase: 'Veuillez sélectionner une phase',
            pmphase: 'Veuillez sélectionner une phase de gestion de projet',
            trade: 'Veuillez sélectionner un métier',
            topic: 'Veuillez sélectionner un sujet',
            subphase: 'Veuillez sélectionner une sous-phase',
            team: 'Veuillez sélectionner les autres membres de l\'équipe',
            verificationCode: 'Veuillez saisir le code de confirmation',
            duplicateTitle: 'Ce nom de projet est déjà utilisé dans l\'entreprise',
            problem: 'Veuillez saisir un défi',
            solution: 'Veuillez saisir une solution',
            topicAndInsightNeeded: 'Il faut impérativement formuler une nouvelle question et choisir un domaine thématique',
            address: 'Veuillez saisir une adresse',
            postcode: 'Veuillez saisir un code postal',
            city: 'Veuillez saisir une ville',
            country: 'Veuillez saisir un pays',
            useNumericValue: 'Doit obligatoirement être un nombre',
            phone: 'Veuillez saisir un numéro de téléphone',
        },
        server: {
            invalidVerificationCode: 'Le code de confirmation n\'est pas valable !',
            invalidToken: 'Jeton non valide',
            invalidFileType: 'Il y a eu une erreur lors du téléchargement de l\'image.\NCela peut probablement être dû à votre connexion, ou à une extension de fichier invalide.\nL\'image doit être un fichier de type : jpeg, png, jpg, gif, svg',
            failedToLoadCalendar: 'Échec du chargement des données du calendrier. Veuillez réessayer plus tard.',
        },
        no_entries_found: 'Aucune entrée trouvée',
    },
    keywords: {
        tenant: 'Entreprise',
        notes: 'Remarques',
        todo: 'A faire',
        checked_by_user: 'Vérifié par',
        needscheck: 'Vérifier ?',
        check: 'Vérifier',
        error: 'Error',
        worksheetAbbr: 'FT',
        IC: 'CL',
        CK: 'PR',
        yes: 'Oui',
        no: 'Non',
        and: 'et',
        or: 'ou',
        show: 'Afficher',
        empty: 'vide',
        select: 'Choisir',
        save: 'Enregistrer',
        update: 'Mise à jour',
        remove: 'Supprimer',
        delete: 'Supprimer',
        enable: 'Activer',
        enabled: 'Activé',
        disable: 'Désactiver',
        disabled: 'Désactivé',
        clear: 'Supprimer la sélection',
        back: 'Retour',
        cancel: 'Annuler',
        close: 'Fermer',
        logout: 'Se déconnecter',
        login: 'Se connecter',
        register: 'S\'inscrire',
        title: 'Titre',
        account: 'Compte d\'utilisateur',
        myAccount: 'Mon compte',
        notification: 'Notification | Notifications',
        subscription: 'Abonnement',
        settings: 'Paramètres',
        privacy: 'Confidentialité',
        email: 'E-mail',
        password: 'Mot de passe',
        new: 'Nouveau',
        newProject: 'Nouveau projet',
        deleteProject: 'Supprimer le projet',
        editProject: 'Mettre à jour le projet',
        description: 'Description',
        firstname: 'Prénom',
        lastname: 'Nom de famille',
        at: 'chez',
        actions: 'Actions',
        creator: 'Créateur',
        search: 'Recherche',
        send: 'Envoyer',
        confirm: 'Confirmer',
        edit: 'Éditer',
        private: 'Privé',
        users: 'Utilisateurs',
        phone: 'Téléphone',
        add: 'Ajouter',
        address: 'Adresse',
        additionalAddress: 'Adresse supplémentaire',
        postcode: 'Code postal',
        place: 'Ville',
        country: 'Pays',
        order: 'Tri',
        abbreviation: 'Abréviation',
        name: 'Nom',
        income: 'Revenu',
        perMonth: 'Par mois',
        perYear: 'Par année',
        calendar: 'Calendrier',
        copy: 'Copier',
        copied: 'Copié',
        all: 'Tous',
        question: 'Question | Questions',
        cloning: 'Clonage',
        knowledge: 'Connaissance',
        project: 'Projet | Projets',
        worksheet: 'Feuille de travail',
        worksheets: 'Feuilles de travail',
        trade: 'Corps de métier | Métiers',
        topic: 'Thème | Thèmes',
        tradesTopics: 'Thèmes des métiers',
        phasesforTrades: 'Phases pour les corps de métier',
        phase: 'Phase',
        phases: 'Phases',
        tradesPhases: 'Phases des métiers',
        subPhase: 'Sous-phase',
        projectManagement: 'Gestion de projet',
        experience: 'Expérience',
        experiences: 'Expériences',
        lesson: 'Enseignement | Enseigner',
        problem: 'Défi',
        possibleSolution: 'Question possible',
        lessonsFor: 'Enseigner pour',
        responsible: 'Responsable',
        reports: 'A faire',
        company: 'Société | Sociétés',
        accepting: 'Accepter',
        contacttill: 'Rendez-vous',
        solution: 'Notes',
        checked: 'Vérifié',
        checkedBy: 'Vérifié par',
        contactEmail: 'E-mail de contact',
        allPhases: 'Toutes les phases',
        appliedLessons: 'Enseignements appliqués',
        teamMembers: 'Membres de l\'équipe',
        concept: 'Thème global | Thèmes globaux',
        pmConcept: 'Sous-phase globale | Sous-phases globales',
        conceptTitle: 'Titre de thème global',
        done: 'Fait',
        print: 'Imprimer',
        weekly: 'Hebdomadaire',
        biweekly: 'Toutes les deux semaines',
        monthly: 'Mensuel',
        quarterly: 'Trimestriel',
        inspectionCheckList: 'Liste de contrôle d\'inspection',
        tag: 'Balise | Balises',
        default: 'Par défaut',
        feature: 'Fonction | Caractéristiques',
        filteringSetting: 'Réglage du filtre',
        filter: 'Filtrer',
        allTags: 'Toutes les balises',
        allPMSubPhases: 'Toutes les sous-phases',
        reset: 'Réinitialiser',
        newTag: 'Nouvelle balise',
        structure: 'Structure | structures',
        newRisk: 'Nouveau risque',
        risk: 'Risque',
        color: 'Couleur',
        noColor: 'Pas de couleur',
        newDynamicField: 'Nouvel attribut',
        dynamicField: 'Attribut | Attribute',
        dynamicFieldInWorksheet: 'Champ dynamique dans les feuilles de calcul',
        dynamicFieldName: 'Nom de l\'attribut',
        msIntegration: 'Microsoft Teams et Planificateur',
        updateDynamicField: 'Mettre à jour l\'attribut',
        export: 'Exportation',
        moreInfo: 'Plus d\'infos',
        insight: 'Question',
        integration: 'Intégration | Intégrations',
        maximize: 'Maximiser',
        disconnect: 'Déconnexion',
        connect: 'Connecter',
        tab: 'Onglet',
        include: 'Inclus',
        finish: 'Quitter',
        value: 'Valeur',
        cost: 'Coût (CHF)',
        probability: 'Probabilité (%)',
        impact: 'Impact (CHF)',
    },
    print: {
        trade: 'Corps de métier | métiers',
        phase: 'Phase',
        todo: 'A faire',
        insight: 'Question',
        solution: 'Notes',
        responsible: 'Responsable',
        contacttill: 'Rendez-vous',
        done: 'Fait',
        needscheck: 'Vérifier ?',
        checked: 'Vérifié',
        checked_by_user: 'Vérifié par',
        cost: 'Coût (CHF)<br>(K)',
        probability: 'Probabilité (%)<br>(W)',
        impact: 'Impact (CHF)<br>(R/{divider}) x K x W',
    },
    labels: {
        inheritedProject: 'Projet hérité',
        parentLesson: 'Leçon parente',
        noParentLessons: 'Aucune leçon disponible',
        msTeamsAndPlanner: 'Microsoft Teams et Planificateur (Métiers et gestion de projet uniquement)',
        projectOnly: 'Visible uniquement par toi et les autres membres du projet',
        myLessons: 'Afficher mes enseignements',
        projectManagementPhases: 'Phases de gestion de projet',
        pMPhase: 'Phase PM | Phases PM',
        otherTeamMembers: 'Autres utilisateurs AppEx',
        externalTeamMembers: 'Membres externes de l\'équipe (sans licence AppEx)',
        msUsers: 'Utilisateur Microsoft',
        newWorksheet: 'Nouvelle feuille de calcul',
        updateWorksheet: 'Modifier la feuille de calcul',
        lessonFor: 'Enseignement pour',
        addNewLesson: 'Ajouter une nouvelle leçon',
        loginOut: 'Déconnexion',
        passwordForgotten: 'Mot de passe oublié ?',
        newKnowledge: 'Nouvelle connaissance',
        notifications: 'Notifications',
        youAreJoining: 'Vous rejoignez',
        newProject: 'Nouveau projet',
        updateProject: 'Mettre à jour le projet',
        newTopic: 'Nouveau thème',
        updateTopic: 'Mettre à jour le thème',
        newTrade: 'Nouveau métier',
        updateTrade: 'Mettre à jour le métier',
        newPhase: 'Nouvelle phase',
        updatePhase: 'Mettre à jour la phase',
        newSubPhase: 'Nouvelle sous-phase',
        updateSubPhase: 'Mettre à jour la sous-phase',
        updateAt: 'Mis à jour le',
        changedBy: 'Modifié par',
        addNewQuestion: 'Ajouter une nouvelle question',
        searchInLessons: 'Rechercher dans les enseignements',
        passwordRecovery: 'Récupération du mot de passe',
        resetPassword: 'Réinitialiser le mot de passe',
        changePassword: 'Changer le mot de passe',
        verificationCode: 'Code de confirmation',
        ResendVerificationEmail: 'Renvoyer l\'e-mail de confirmation',
        privateLessons: 'Propres enseignements',
        FilterSubphasesAndLessons: 'Filtrer les sous-phases et les enseignements',
        filterResolved: 'Afficher les activités terminées',
        showEverything: 'Tout afficher',
        mandatoryLesson: 'Faut-il toujours choisir cet enseignement dans les fiches de travail ?',
        lessonAsQuestion: 'L\'enseignement formulé comme une question',
        createALesson: 'Créer un enseignement',
        selectAll: 'Tout sélectionner',
        createWorksheet: 'Créer une feuille de calcul',
        newPrivateLessonFor: 'Nouvel enseignement propre pour',
        newLesson: 'Nouvel enseignement',
        editLesson: 'Modifier l\'enseignement',
        memberSince: 'Membre depuis',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirmEmail: 'E-mail de confirmation',
        editAccount: 'Modifier le compte',
        calendarTutorial: 'Comment vous abonner à votre calendrier',
        calendarTutorialOutlook: 'Outlook',
        calendarTutorialOutlookInstructions: 'Dans Outlook, accédez au calendrier, sélectionnez "Ajouter un calendrier", puis "À partir du Web". Collez le lien copié ici.',
        calendarTutorialGoogle: 'Google Agenda',
        calendarTutorialGoogleInstructions: 'Dans Google Agenda, cliquez sur le "+" à côté de "Autres agendas" et sélectionnez "À partir de l\'URL". Collez le lien copié ici.',
        calendarTutorialApple: 'Calendrier Apple',
        calendarTutorialAppleInstructions: 'Dans Calendrier Apple, allez dans "Fichier" > "Nouvel abonnement au calendrier...". Collez le lien copié ici.',
        calendarDescription: 'Ici vous pouvez trouver vos flux de calendrier personnels pour vos tâches.',
        calendarLanguageSelection: 'Lien du calendrier dans une autre langue',
        accountDetails: 'Détails du compte',
        noLessons: 'Pas d\'enseignements',
        noLessonsInThisWorksheet: 'Aucun enseignement n\'a encore été sélectionnée dans cette feuille de calcul',
        noLessonsToCheck: 'Pas d\'enseignement à vérifier',
        noLessonsHaveBeenSelectedToCheck: 'Aucun enseignement n\'a été sélectionné pour l\'examen',
        welcomeToAppex: 'Bienvenue chez Appex',
        howDoesAppexWork: 'Comment fonctionne Appex ?',
        insightPlaceholder: 'Question à laquelle il faut répondre',
        actionNeeded: 'Action requise ?',
        needsCheck: 'Vérifier ?',
        noActionNeededTitle: 'Aucune action n\'est nécessaire',
        noActionNeededBody: 'Pour le moment, il n\'y a pas lieu d\'agir',
        projectSpecificQuestions: 'Questions spécifiques au projet',
        newQuestion: 'Nouvelle question',
        enterDate: 'Veuillez sélectionner une date',
        projectSpecificLesson: 'Nouvelle question pour ce projet (devient un enseignement spécifique au projet)',
        projectSpecificQuestion: 'Nouvelle question pour ce projet',
        updateProjectSpecificQuestion: 'Mettre à jour la question spécifique au projet',
        noLessonCreatedTitle: 'Aucun enseignement créé',
        noLessonCreatedBody: 'Veuillez d\'abord ajouter un enseignement',
        newCompany: 'Créer une nouvelle entreprise',
        updateCompany: 'Mettre à jour l\'entreprise',
        amountOfLessons: 'Nombre d\'enseignements',
        sendInvitation: 'Envoyer une invitation',
        cloneData: 'Cloner des données',
        clonedData: 'Connées clonées',
        addNewPrivateLesson: 'Ajouter une nouvel enseignement propre',
        editWorksheet: 'Compléter la feuille de calcul',
        enableSynchronisation: 'Faut-il configurer la synchronisation ? > Activer la synchronisation',
        showEmptyTopics: 'Afficher les thèmes vides',
        showEmptySubphases: 'Afficher les sous-phases vides',
        showEmptyTrades: 'Afficher les métiers vides',
        assignAllDataToUser: 'Associer toutes les données',
        deleteAllData: 'Effacer toutes les données',
        promoteToAdmin: 'Promouvoir comme administrateur',
        demoteToUser: 'Reléguer comme utilisateur',
        displayColumns: 'Afficher les colonnes',
        receiveEmailNotifications: 'Recevoir des notifications par e-mail pour enregistrer les nouveaux enseignements',
        lastOnline: 'Dernièrement en ligne',
        phaseDescription: 'De quoi s\'agit-il dans cette phase ?',
        orderExplanation: 'Tri (par ex. numéro 1 - 100)',
        lessonLink: 'Lien',
        lessonSolution: 'Solution',
        moreInformation: 'Plus d\'informations',
        tooltips: {
            hbButton: 'Afficher la feuille de calcul',
            prButton: 'Afficher le document de contrôle',
            newWorksheetFor: 'Créer une nouvelle feuille de calcul pour {0}',
        },
        featureDynamicTab: 'Activer l\'onglet x',
        newTag: 'Créer une nouvelle balise',
        updateTag: 'Mettre à jour la balise',
        saveProjectToAddExternalTeamMember: 'Le projet doit être enregistré en premier',
        addExternalTeamMember: ' Ajouter des membres externes à l\'équipe',
        manageExternalTeamMember: 'Gérer les membres externes de l\'équipe',
        personalTasks: 'Tâches personnelles',
        openTasks: 'Tâches ouvertes',
        doneTasks: 'Tâches terminées',
        allTasks: 'Toutes les tâches',
        nonCheckedChecks: 'Non vérifiées',
        checkedChecks: 'Vérifiées',
        allNeedChecks: 'À vérifier',
        allChecks: 'Toutes',
        sendEmail: 'Envoyer un e-mail',
        uploadLogo: 'Télécharger le logo',
        selectLogo: 'Choisir un logo',
        selectLogoCrop: 'Sélectionner le recadrage',
        deleteLogo: 'Supprimer le logo',
        addToKnowledgeBase: 'Proposer pour la base de connaissances',
        irreversibleAction: 'C\'est une <span class="has-text-weight-semibold is-uppercase has-text-danger">action irréversible!</span>',
        editInKnowledgeTab: 'Ne peut être édité que dans Connaissance',
        showUnread: 'Afficher uniquement les messages non lus',
        markAsRead: 'Marquer comme lu',
        markAllAsRead: 'Marquer tout comme lu',
        loadMore: 'Charger plus',
        noUnreadLeft: 'Plus de messages non lus',
        tabTitle: 'Onglet titre',
        lessonTitle: 'Titre de l\'enseignement',
        processTitle: 'Titre du processus',
        subProcessTitle: 'Sous-titre du processus',
        dynamicTab: 'Onglet dynamique',
        createdBy: 'Créé par',
        createdAt: 'Créé le',
        byParentProject: 'Hérité du projet parent',
    },
    placeholder: {
        projectTitle: 'Nom du projet',
        projectDescription: 'Description du projet',
        teamMember: 'Choisir les autres membres de l\'équipe',
        selectExternalTeamMember: 'Sélectionner les membres externes de l\'équipe',
        selectAUser: 'Choisir un utilisateur',
        selectAnAction: 'Sélectionnez une action',
        selectPhase: 'Choisir les phases',
        selectTrade: 'Choisir le métier',
        selectProcess: 'Sélectionnez le %{companyProcessName}',
        selectPMPhase: 'Choisir les phases de gestion de projet',
        selectSubPhase: 'Choisir la sous-phase',
        selectXProcess: 'Sélectionner un processus',
        selectTopic: 'Choisir le domaine thématique',
        selectProject: 'Choisir le projet',
        selectResponsible: 'Veuillez rendre quelqu\'un responsable',
        selectTag: 'Sélectionner les balises',
        msUsers: 'Sélectionner les utilisateurs Microsoft',
        newPassword: 'Nouveau mot de passe',
        newLessonPlaceholder: ' - Est-ce un problème de conséquences sur les coûts ou les délais?\n\
    - Cet enseignement existe-t-il déjà dans la base de connaissances?\n\
    - S\'agit-il d\'un thème général (gestion de projet) ou spécifique à un corps de métier ? Quel est le corps de métier concerné ? \n\
    - A quelle(s) étape(s) faut-il agir pour prévenir le problème?\n\
    - Quelle est la question à poser pour attirer l\'attention sur le problème?\n\
    - Assurance qualité : cette question est-elle compréhensible pour une autre personne à ce stade ?',
        newLessonTransferPlaceholder: ' - S\'agit-il d\'un problème de conséquences sur les coûts ou les délais?\n\
    - S\'agit-il d\'un thème général (gestion de projet) ou spécifique à un corps de métier ? Quel est le corps de métier concerné ?\n\
    - A quelle(s) étape(s) faut-il agir pour prévenir le problème?\n\
    - Quelle est la question à poser pour attirer l\'attention sur le problème?\n\
    - Assurance qualité : cette question est-elle compréhensible pour une autre personne à ce stade ?',
        chooseSubphase: 'Sélectionner une sous-phase',
        companyDescription: 'Veuillez saisir une brève description de l\'entreprise',
        lessonLink: 'Exemple : https://www.example.com/',
        lessonSolution: 'Ont-ils une solution ?',
        selectParentLesson: 'Cet enseignement doit-il être subordonné à une question existante ? Si oui, sélectionner la question',
    },
    messages: {
        logOutFirst: 'Vous devez vous déconnecter en premier',
        passwordRecoveryEmailHasBeenSent: 'L\'email de récupération du mot de passe a été envoyé',
        passwordChangedSuccessfully: 'Le mot de passe a été changé avec succès',
        AnErrorHasOccurredPleaseTryAgain: 'Une erreur est survenue, veuillez réessayer !',
        RecoveryEmailIsOnlyValidFor3Hours: 'L\'e-mail de récupération du mot de passe n\'est valable que pendant 3 heures !',
        thankYouEmailConfirmed: 'Merci beaucoup, l\'adresse e-mail a été confirmée !',
        youHaveSuccessfullyLoggedIn: 'Connecté avec succès !',
        noChangesDetected: 'Aucun changement détecté !',
        changesSavedSuccessfully: 'Les modifications ont été enregistrées avec succès',
        CompanyUsersRegisterLink: 'Enregistrer les utilisateurs de l\'entreprise Lien :',
        LinkCopiedToClipboard: 'Le lien suivant a été copié dans le clipboard : ',
        contactUsIfYouNeedHelp: 'Veuillez nous contacter si vous avez besoin d\'aide',
        areYouSureYouWantToDelete: 'Vraiment supprimer ?',
        cloneLessons: 'Cloner des enseignements ?',
        DataIsClonedFromMsg: 'Les données sont clonées par "AppEx GmbH"',
    },
    introMessages: {
        projectOverViewTradeTabIntroMessage: 'C\'est ici que sont créées et modifiées les feuilles de travail spécifiques aux phases pour les différents corps de métier',
        projectOverViewPMTabIntroMessage: 'Des feuilles de travail spécifiques aux phases pour les thèmes de gestion de projet sont créées et traitées ici',
        projectOverViewXTabIntroMessage: 'Ici, les feuilles de travail spécifiques à %{companyProcessName} sont créées et modifiées.',
        approvalListPageIntroMessage: 'Toutes les leçons qui n\'ont pas encore été acceptées sont listées ici.\n\
        Les jauges peuvent être éditées et acceptées ou supprimées',
        notificationsIntroMessage: 'Notifications intro messages',
        homeHowDoesAppexWork: ' - Dans chaque projet, les défis conduisent à des expériences. Certaines de ces expériences peuvent servir de leçons pour les projets futurs.<br/>\
    - Les collaborateurs documentent ces expériences et les transforment en enseignements, qui sont formulés sous forme de questions. Ces questions sont attribuées à la phase du projet dans laquelle elles doivent être posées afin d\'éviter les problèmes.<br/>\
    - Les collaborateurs créent des fiches de travail avec les questions pertinentes pour leurs projets à partir de la base de connaissances. Cela permet de s\'assurer que les expériences et les leçons apprises sont appliquées dans les nouveaux projets, à la fois pendant la préparation d\'une phase et en tant que contrôle de qualité à la fin de la phase.<br/>\
    - Les enseignements sont classés par corps de métier ou par thème de gestion de projet s\'ils sont de nature générale ou s\'ils ont un caractère de processus.<br/>\
    - Les phases, les corps de métiers ou les thèmes de gestion de projet peuvent être créés ou modifiés par un administrateur.<br/>\
    - Les collaborateurs peuvent créer des projets et leur attribuer des collaborateurs, des phases et des corps de métier. Les collaborateurs peuvent enregistrer leurs expériences dans leurs projets et les formuler sous forme de leçons pour la base de connaissances. Les administrateurs peuvent adapter et partager ces enseignements',
        StoreUpdateExperienceIntroMessage: 'Il est possible de consigner ici les enseignements ou les problèmes rencontrés dans le projet, qui pourront à l\'occasion être transférés en enseignements pour la base de connaissances',
        howToConnectToMSTeams: '\n\
        <p>\n\
                La connexion d\'AppEx avec Microsoft permet l\'exportation de projets et de \n\
                Fiches de travail sur les équipes et Planificateur.\n\
                </p>\n\
                <ul>\n\
                    <h6><li>Etablir une connexion:</li></h6>\n\
                    <ul>\n\
                        <li>L\'administrateur Microsoft AppEx choisit Admin -> Intégrations -> Connecter</li>\n\
                        <ul>\n\
                            <li>Recommandation : Créer un compte Microsoft Admin dans Microsoft, qui ne sera utilisé que pour AppEx</li>\n\
                        </ul>\n\
                        <li>n\n\
                            Sur la page d\'autorisation de Microsoft, cocher la case "Donner son accord" et accepter l\'autorisation.\n\
                        </li>\n\
                        <li>La connexion à Microsoft est établie. (Il s\'agit d\'un processus unique)</li>\n\
                    </ul>\n\
                    <h6><li>Désengagement :</li></h6>\n\
                    <ul>\n\
                    <li>Cliquer sur annuler</li>\n\
                    <li>Confirmer l\'annulation</li>\n\
                    <li>La connexion est automatiquement annulée</li>\n\
                    <li><b class="has-text-danger">Il faut attendre 30 minutes</b></li>Npour une reconnexion.\n\
                    </ul>\n\
                        <h6><li>Veuillez prendre en compte:</li></h6>\n\
                        <ul>\n\
                            <li>\n\
                                Équipes, projets, feuilles de travail et tâches et toutes les autres fonctions dans\n\
                                Microsoft sont créés au nom de l\'administrateur Microsoft qui a créé \n\
                                connexion autorisée (à prendre en compte lors de la dénomination).\n\
                            </li>\n\
                            <li>\n\
                                Pour les projets liés à AppEx, l\'administrateur de Microsoft doit pouvoir utiliser \n\
                                ne doit pas être modifiée ou le lien supprimé.\n\
                            </li>\n\
                            <li>La création d\'un projet en équipe peut prendre jusqu\'à plusieurs heures\n\
                                (observer l\'affichage de l\'état jusqu\'à ce que 5 étapes soient terminées).</li>\n\
                            <li>\n\
                                 Les droits et rôles de l\'administrateur Microsoft qui gère la connexion\n\
                                 ne doivent pas être modifiés ultérieurement.\n\
                            </li>\n\
                        </ul>\n\
                    </ul>\n\
        ',
    },
    emptyMessages: {
        noProjectMessageHeader: 'Pas encore de projet créé',
        noProjectMessageBody: 'Veuillez d\'abord créer un projet en haut à droite',
        noLessonMessageHeader: 'Aucun enseignement n\'a encore été créé',
        noLessonMessageBody: 'Veuillez d\'abord ajouter un enseignement',
        allLessonsAccepted: 'Pour le moment, tous les enseignements sont acceptés',
        noExperienceHeader: 'Pas encore d\'expérience',
        noExperienceBody: 'Documenter ci-dessus un défi et, le cas échéant, esquisser sa problématique possible (peut être mis à jour ultérieurement.)',
        noEntryHeader: 'Aucune entrée trouvée',
        noEntryBody: 'Malheureusement, il n\'y a pas d\'entrées ici',
        noTradeOpenTasksHeader: '',
        noTradeOpenTasksBody: 'Cette personne n\'a pas de tâches ouvertes pour les phases et les corps de métier sélectionnés',
        noPmOpenTasksHeader: '',
        noPmOpenTasksBody: 'Cette personne n\'a pas de tâches ouvertes pour les phases sélectionnées',
        noXOpenTasksBody: 'Cette personne n’a aucune tâche ouverte pour le %{companyProcessName} sélectionné.',
        msIntegrationHeader: 'Intégration Microsoft en attente',
        msIntegrationBody: 'Alors que l\'intégration Microsoft est en attente, aucune feuille de calcul ne peut être créée',
        projectEditDisabledHeader: 'Édition de projet désactivée pour le projet "{0}"',
        projectEditDisabledBody: 'Si la connexion Microsoft est révoquée, le projet ne peut pas être édité. Rétablir la connexion Microsoft pour activer le projet',
    },
    confirmRemoveMessages: {
        confirmDelete: 'Veuillez saisir <span class="has-text-weight-semibold has-text-danger">"{0}"</span> pour continuer ou quitter ce mode pour annuler le processus',
        confirmDeleteMicrosoftTeam: 'L\'équipe Microsoft (et toutes les ressources associées) liée à ce projet sera également supprimée',
        trade: {
            header: 'Vous allez supprimer le corps de métier "{0}". Les ouvrages supprimés ne peuvent PAS être restaurés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression de l\'ouvrage entraîne la suppression des enseignements et de toutes les données qui en dépendent, y compris les fiches de travail, les enseignements appliqués, etc',
        },
        pmPhase: {
            header: 'Vous allez supprimer la phase "{0}". Les phases supprimées ne peuvent PAS être restaurées ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression de la phase entraîne la suppression des sous-phases, des enseignements et de toutes les données dépendantes, y compris les fiches de travail, les enseignements appliqués, etc',
        },
        pmSubPhase: {
            header: 'Vous allez supprimer la sous-phase "{0}". Les sous-phases retirées ne peuvent PAS être restaurées ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression de la sous-phase entraîne la suppression des enseignements et de toutes les données qui en dépendent, y compris les fiches de travail, les enseignements appliqués, etc',
        },
        xProcess: {
            header: 'Vous allez supprimer le X Process "{0}". Les X Process supprimés ne peuvent PAS être restaurés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression du X Process entraîne la suppression du X Sub Process, des tutoriels et de toutes les données dépendantes, y compris les feuilles de calcul, les tutoriels appliqués, etc',
        },
        xSubProcess: {
            header: 'Vous allez supprimer le X Sub Process "{0}". Les X Sub Process supprimés ne peuvent PAS être restaurés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'En supprimant le X Sub Process, les enseignements et toutes les données dépendantes, y compris les feuilles de calcul, les enseignements appliqués, etc. sont supprimées',
        },
        projectDelete: {
            header: 'Vous allez supprimer le projet "{0}". Les projets supprimés ne peuvent PAS être restaurés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression du projet entraîne la suppression des feuilles de calcul et de toutes les données dépendantes, y compris les enseignements appliqués, etc',
        },
        projectUpdate: {
            header: 'Vous êtes sur le point de supprimer certaines entités du projet "{0}". Les entités retirées NE PEUVENT PAS être restaurées ! Êtes-vous ABSOLUMENT SÛR ?',
            body: 'Liste des entités à supprimer :',
        },
        topic: {
            header: 'Vous allez supprimer le domaine thématique "{0}". Les domaines supprimés ne peuvent PAS être restaurés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression du domaine thématique entraîne la suppression de tous les enseignements dépendants',
        },
        phase: {
            header: 'Vous allez supprimer la phase "{0}". Les phases supprimées ne peuvent PAS être restaurées ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'La suppression de la phase entraîne la suppression de toutes les jauges dépendantes',
        },
        worksheet: {
            header: 'Vous allez supprimer la feuille de calcul du projet "{0}". Les feuilles de calcul retirées ne peuvent PAS être restaurées ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'Toutes les entrées seront également supprimées',
        },
        pmWorksheet: {
            header: 'Vous allez supprimer la feuille de calcul du projet "{0}". Les feuilles de calcul retirées ne peuvent PAS être restaurées ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'Toutes les entrées seront également supprimées',
        },
        users: {
            header: 'Vous allez supprimer les utilisateurs suivants',
            body: 'Toutes les données des utilisateurs sélectionnés (projets, enseignements appliqués, enseignements, expériences, fiches de travail et thèmes globaux) seront supprimées si elles ne sont pas attribuées à un autre utilisateur',
        },
        company: {
            header: 'Vous supprimez <span class="has-text-weight-semibold has-text-danger">"{0}"</span> société !',
            body: 'Toutes les données (projets, enseignements appliqués, enseignements, expériences, fiches de travail, thèmes globaux, utilisateurs et ainsi de suite) seront supprimées !',
        },
        tag: {
            header: 'Vous êtes sur le point de supprimer le tag "{0}". Les tags supprimés ne peuvent PAS être récupérés ! Êtes-vous ABSOLUMENT sûr ?',
            body: 'En supprimant le tag, il sera retiré de tous les enseignements',
        },
    },
    toastMessages: {
        delete: {
            generic: 'Le {x} a été supprimé avec succès',
            lesson: 'L\'enseignement a été supprimée avec succès',
            trade: 'Les métiers ont été supprimés avec succès',
            topic: 'Le domaine thématique a été supprimé avec succès',
            phase: 'La phase a été supprimée avec succès',
            pmPhase: 'La phase a été supprimée avec succès',
            pmSubPhase: 'Les sous-phases ont été supprimées avec succès',
            experience: 'Les expériences ont été supprimées avec succès',
            worksheet: 'La feuille de calcul a été supprimée avec succès',
            pmWorksheet: 'La feuille de calcul a été supprimée avec succès',
            tag: 'La balise a été supprimé avec succès',
        },
        store: {
            generic: 'Le {x} a été enregistré avec succès',
            lesson: 'L\'enseignement a été enregistré avec succès',
            trade: 'Le métier a été enregistré avec succès',
            topic: 'Le domaine thématique a été enregistré avec succès',
            phase: 'La phase a été enregistrée avec succès',
            pmPhase: 'La phase a été enregistrée avec succès',
            pmSubPhase: 'La sous-phase a été enregistrée avec succès ',
            dynamicField: 'L’attribut a été enregistré avec succès',
            worksheet: 'La feuille de calcul a été enregistrée avec succès',
            experience: 'L\'enseignement a été enregistré avec succès et effacé de l\'expérience',
            cloningSuccessful: 'Les données ont été correctement transférées',
            email: 'L\'email a été envoyé avec succès',
            tag: 'La balise a été enregistré avec succès',
        },
        update: {
            generic: 'Le {x} a été mis à jour avec succès',
            account: 'Le compte a été mis à jour avec succès',
            lesson: 'L\'enseignement a été mis à jour avec succès',
            trade: 'Le métier a été mis à jour avec succès',
            topic: 'Le domaine thématique a été actualisé avec succès',
            phase: 'La phase a été mise à jour avec succès',
            pmPhase: 'La phase a été mise à jour avec succès',
            pmSubPhase: 'La sous-phase de gestion de projet a été mise à jour avec succès',
            dynamicField: 'L’attribut a été mis à jour avec succès',
            worksheet: 'La feuille de calcul a été mise à jour avec succès',
            tag: 'La balise a été mis à jour avec succès',
            emailedOpenTasks: 'E-mails envoyés avec succès',
        },
        error: {
            worksheet: 'La feuille de calcul n\'a pas pu être mise à jour',
            cannot_load_appliedLessons: 'Les enseignements n\'ont pas pu être chargées',
            cannot_remove_worksheet: 'La feuille de calcul n\'a pas pu être supprimée',
            cloningError: 'Désolé, les données n\'ont pas pu être clonées',
            lesson: 'Impossible de supprimer l\'enseignement',
            error: 'Une erreur est survenue',
        },
    },
    navigation: {
        switcher: {
            changeTo: 'Passer à',
            native: {
                name: 'AppEx',
                description: 'Connaissances et projets',
            },
            orders: {
                name: 'Commandes',
                description: 'Gérer les objets de livraison',
            },
            loading: 'Ouverture',
        },
        main: {
            objects: 'Mes projets',
            reports: 'A faire',
            experiences: 'Mes expériences',
            approval: 'Nouvelles connaissances',
            notifications: 'Messages',
            setup: 'Connaissance',
            system: 'Admin',
            register: 'S\'inscrire',
            login: 'Se connecter',
            logout: 'Se déconnecter',
        },
    },
    notificationMessages: {
        applied_lesson_stored: 'a ajouté une question à la feuille de travail du métier : <b>{0}</b> et de la phase : <b>{1}</b>',
        pm_applied_lesson_stored: 'a ajouté une question à <b>{0}</b>',
        x_applied_lesson_stored: 'a ajouté une question à <b>{0}</b>',
        project_stored: 'a créé le projet <b>{0}</b>',
        project_updated: 'a modifié le projet <b>{0}</b>',
        project_deleted: 'a supprimé le projet <b>{0}</b>',
        worksheet_stored: 'a créé une feuille de calcul pour le métier : <b>{0}</b> et la phase : <b>{1}</b>',
        worksheet_edited: 'édite une feuille de travail pour le métier : <b>{0}</b> et la phase : <b>{1}</b',
        worksheet_deleted: 'a supprimé une feuille de calcul pour le métier : <b>{0}</b> et la phase : <b>{1}</b>',
        pm_worksheet_stored: 'a créé la feuille de calcul PM <b>{0}</b',
        pm_worksheet_edited: 'a traité la feuille de calcul PM <b>{0}</b>',
        pm_worksheet_deleted: 'a supprimé la feuille de calcul PM <b>{0}</b>',
    },
    integrations: {
        introduction: 'Les intégrations vous permettent d’intégrer des applications tierces dans votre flux de travail AppEx.',
    },
    orders: {
        title: 'Commande',
        phases: 'Phases PM',
        deliveryObjectCompletionPercentage: 'Objets livrables %',
        bimTargetCompletionPercentage: 'Objectifs BIM %',
        bimUseCaseCompletionPercentage: 'Cas d\'usage BIM %',
        link: 'Lien',
    },
};

export default fr;
